module.exports = __webpack_public_path__ + "df330705d6a0080cf69fd5ba52337120.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-18.cur
// module id = 445
// module chunks = 0